module.exports = __webpack_public_path__ + "static/media/logoCenter.8d5a2168.png";